<template>
  <div class="div">
    <el-tabs v-model="activeName" type="card" style="height: 100%">
      <el-tab-pane label="电价格表" name="电">
        <ElectricityPrice ref="ElectricityPrice"></ElectricityPrice>
      </el-tab-pane>
      <el-tab-pane label="水价格表" name="水">
        <WaterPrice ref="WaterPrice"></WaterPrice>
      </el-tab-pane>
      <el-tab-pane label="气价格表" name="气">
        <GasPrice ref="GasPrice"></GasPrice>
      </el-tab-pane>
      <el-tab-pane label="油价格表" name="油">
        <OilPrice ref="GasPrice"></OilPrice>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ElectricityPrice from "./ElectricityPrice/ElectricityPrice.vue";
import WaterPrice from "./WaterPrice/WaterPrice.vue";
import GasPrice from "./GasPrice/GasPrice.vue";
import OilPrice from "./OilPrice/OilPrice.vue";
export default {
  data() {
    return {
      activeName: "电",
    };
  },
  props: {},
  components: { ElectricityPrice, WaterPrice, GasPrice, OilPrice },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
</style>
